import { createSelector } from 'reselect';
import {
    filter, find, get,
} from 'lodash';

/**
 * Base Selectors
 */
const getEntities = (state) => get(state, 'app.database.memberEmails', {});
const getAuth = (state) => get(state, 'app.auth', {});
const getEntityId = (state, id) => id;

/**
 * Selector Builders
 */
export const buildMemberEmailsSelector = () => createSelector([getEntityId, getEntities, getAuth], (entityId, entities, authState) => filter(entities, { member_id: entityId }));
export const buildMemberEmailSelector = () => createSelector([getEntityId, getEntities], (entityId, entities) => find(entities, { id: entityId }));
export const buildEmailsSelector = () => createSelector([
    getEntityId, getAuth, getEntities,
], (entityId, authState, entities) => find(entities, { id: entityId, member_id: authState.user.member.id }));
